import { EDITOR_NAME_PART_KEYS, joinEditorNameParts } from '@messenger/lotus'
import { fieldKeyToWritableCaseField } from './toEditorTextBoxCaseData'

export const nameOfDeceasedFromCase = (
  caseRecord: Readonly<Record<string, unknown>>,
): string =>
  joinEditorNameParts(
    Object.fromEntries(
      Object.entries(EDITOR_NAME_PART_KEYS).flatMap(([part, fieldKey]) => {
        const writable = fieldKeyToWritableCaseField(fieldKey)
        if (!writable) return []
        const value = caseRecord[writable.column]
        return [[part, typeof value === 'string' ? value : '']]
      }),
    ),
  )

export const nameOfDeceasedPartColumns = (): ReadonlySet<string> =>
  new Set(
    Object.values(EDITOR_NAME_PART_KEYS).flatMap((fieldKey) => {
      const writable = fieldKeyToWritableCaseField(fieldKey)
      return writable ? [writable.column] : []
    }),
  )
